import PageIntro from '../components/PageIntro';

export default function Privacy() {
  return (
    <div className="page-shell space-y-8">
      <PageIntro
        eyebrow="Privacy"
        title="Clear language about what information is collected and why."
        description="Legal pages should still feel readable and trustworthy, so this layout keeps policy content structured without looking like an afterthought."
      />

      <section className="section-card-strong p-8">
        <div className="legal-stack">
          <article className="legal-panel">
            <h2 className="mb-3 text-3xl text-primary-dark">Information we collect</h2>
            <p className="section-copy text-base">
              Victoria's Place collects information you provide directly, such as when you submit
              forms, make donations, or contact the organization.
            </p>
          </article>
          <article className="legal-panel">
            <h2 className="mb-3 text-3xl text-primary-dark">How we use information</h2>
            <p className="section-copy text-base">
              Information is used to provide and improve services, process donations, communicate
              with families and supporters, and meet legal obligations.
            </p>
          </article>
          <article className="legal-panel">
            <h2 className="mb-3 text-3xl text-primary-dark">Information sharing</h2>
            <p className="section-copy text-base">
              Personal information is not sold or traded and is only shared when described in the
              policy or required to deliver services.
            </p>
          </article>
          <article className="legal-panel">
            <h2 className="mb-3 text-3xl text-primary-dark">Contact us</h2>
            <p className="section-copy text-base">
              Questions about privacy can be sent through the contact page for follow-up.
            </p>
          </article>
        </div>

        <p className="mt-8 text-sm font-medium text-slate-500">
          Last updated: {new Date().toLocaleDateString()}
        </p>
      </section>
    </div>
  );
}
